import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import getTempDashboardUrl from '@src/components/common/Dashboard/utils/getTempDashboardUrl';

export const StyledLink = styled(Link)`
  color: #0046ff;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TempNameLink = (rowData) => {
  const { id, title } =  rowData;
  const url = getTempDashboardUrl(rowData, { isSharing: false, isSaved: false, id})
  return (
  <StyledLink
    to={`${url}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    {title}
  </StyledLink>
  );
};

export default TempNameLink;
